import React from "react";
import { useParams, useRouteMatch } from "react-router-dom";
import { ProductCreatedPageApiHandler } from "./ProductCreatedPageApiHandler";
import { Routes } from "@greeter-venue/utility/Routes";

type Params = {
  id: string;
};

export function ProductCreatedPageRouteHandler() {
  const routeMatch = useRouteMatch<Params>(
    Routes.mainGroup.productCreated.template()
  );

  return <ProductCreatedPageApiHandler id={routeMatch?.params?.id ?? ""} />;
}
